import { medicalRecordsApi } from '../services/api'

/**
 * Pending medical records for menu/dashboard badge:
 * - Teachers: own submissions still in `pending` (GET /self).
 * - Admins (requireAdmin roles): pending in jurisdiction via list API pagination totalCount.
 */
export async function fetchPendingMedicalRecordsCountForRole(
  role: string | undefined | null
): Promise<number> {
  const r = (role || '').toLowerCase()
  if (r === 'teacher') {
    try {
      const response = await medicalRecordsApi.getSelf()
      if (response.data?.success && Array.isArray(response.data.data)) {
        return response.data.data.filter(
          (rec: { approval_status?: string }) =>
            String(rec.approval_status || '').toLowerCase() === 'pending'
        ).length
      }
    } catch {
      return 0
    }
    return 0
  }

  try {
    const response = await medicalRecordsApi.getAll(1, 1, 'pending')
    if (response.data?.success) {
      const p = (response.data as { pagination?: { totalCount?: number } }).pagination
      return typeof p?.totalCount === 'number' ? p.totalCount : 0
    }
  } catch {
    return 0
  }
  return 0
}
